import React, { createContext, useContext, useState } from 'react';
import { translations, useTranslation } from './i18n/translations.js';

// Configuración de idiomas disponibles
const availableLanguages = [
  { code: 'es', name: 'Español' },
  { code: 'ca', name: 'Català' },
  { code: 'en', name: 'English' }
];

// Crear el contexto
const LanguageContext = createContext();

// Hook para usar el contexto de idiomas
export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (context === undefined) {
    throw new Error('useLanguage debe usarse dentro de un LanguageProvider');
  }
  return context;
};

// Proveedor del contexto de idiomas
export const LanguageProvider = ({ children }) => {
  const [currentLanguage, setCurrentLanguage] = useState('es');
  const { t } = useTranslation(currentLanguage);

  const changeLanguage = (languageCode) => {
    if (availableLanguages.find(lang => lang.code === languageCode)) {
      setCurrentLanguage(languageCode);
      // Guardar en localStorage para persistir la preferencia
      localStorage.setItem('preferredLanguage', languageCode);
    }
  };

  // Recuperar idioma preferido al cargar
  React.useEffect(() => {
    const savedLanguage = localStorage.getItem('preferredLanguage');
    if (savedLanguage && availableLanguages.find(lang => lang.code === savedLanguage)) {
      setCurrentLanguage(savedLanguage);
    }
  }, []);

  const value = {
    currentLanguage,
    availableLanguages,
    changeLanguage,
    t
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};
